import { Conversation, Message, Resource } from '@the-real-insight/tri-model';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ChatConversation } from './ChatConversation';
import { Suggestion, Suggestions } from './Suggestions';
import { authenticationAtom, conversationAtom } from '../State';
import { useAtom } from 'jotai';
import { MessageType } from '@the-real-insight/tri-model';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { TextField } from '@fluentui/react/lib/TextField';
import { Link } from '@fluentui/react/lib/Link';
import { useTranslation } from 'react-i18next';
import { userAPI } from '../UserAPI';
import { useSpeech } from '../Speech';
import { IconButton, ActionButton } from '@fluentui/react/lib/Button';
import i18next from 'i18next';
import { MessageBarType } from '@fluentui/react/lib/MessageBar';
import { MessageBar } from '@fluentui/react/lib/MessageBar';
import { formatNumber1 } from '../utilities/format';

const userContext = { firstName: 'Marc', lastName: 'Gille-Sepehri', email: 'marc@thing-it.com', mesh: '65093dfececde3b84a486809' }

interface Properties {
    conversation: Conversation;
    showSuggestions: boolean;
    showLogo: boolean;
    height?: string;
    fullWidth?: boolean;
    resourceSelected?: (resource: any) => void;
    updateConversation?: (conversation: Conversation) => void;
    createConversation?: () => void;
    sampleRequests?: string[];
    toolFilter?: string[];
}

export const ChatExchange = (properties: Properties) => {
    const { t } = useTranslation();
    const [locale] = useState(i18next.resolvedLanguage);
    const [authentication] = useAtom(authenticationAtom) as any;
    const [conversation, setConversation] = useAtom(conversationAtom) as any;
    const [pendingRequest, setPendingRequest] = useState(false);
    const textField = useRef<any>(null);
    const conversationAreaRef = useRef<HTMLDivElement>(null);
    const [inputValue, setInputValue] = useState() as any;
    const [inputFocussed, setInputFocussed] = useState(false);
    const [id, setId] = useState(null) as any;
    const [requestIndex, setRequestIndex] = useState(0);
    const [requests, setRequests] = useState([]) as any;
    const [skillAgentResponse, setSkillAgentResponse] = useState(null);
    const [transcribing, setTranscribing] = useState(false);
    const [agent, setAgent] = useState(null) as any;
    const [chatUpdate, setChatUpdate] = useState(Date.now());
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const [showSampleRequests, setShowSampleRequests] = useState(true);

    // TODO What is this for?
    const handleFeedback = (messageIndex: number, isPositive: boolean) => {
        console.log(`Feedback for message ${messageIndex}: ${isPositive ? 'positive' : 'negative'}`);
    };

    const capitalizeFirstLetter = (value: string) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    const scrollToBottom = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (conversationAreaRef.current) {
                    conversationAreaRef.current.scrollTop = conversationAreaRef.current.scrollHeight;
                }
            });
        });
    };

    const recordRequest = useCallback((request: string) => {
        if (request) {
            setRequests([...requests, request]);
            setRequestIndex(requests.length);
        }
    }, [requests])

    // Drag and drop handlers
    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const handleDragEnter = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        // Only set to false if we're leaving the container entirely
        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
            setIsDragOver(false);
        }
    };

    // Update handleDrop to add files to uploadedFiles
    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        
        const files = Array.from(e.dataTransfer.files);
        setUploadedFiles(prev => [...prev, ...files]);
    };

    // Handler to remove a file
    const handleRemoveFile = (index: number) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const parseMessageChunk = (chunk: string, parsingState: any) => {
        let { newConversation, payloadString } = parsingState;
        const currentMessage = newConversation.messages[newConversation.messages.length - 1];

        while (chunk.length > 0) {
            if (!!payloadString) {
                const payloadEnd = chunk.indexOf('```');

                if (payloadEnd >= 0) {
                    console.log('===> Complete parsing payload');

                    payloadString += chunk.substring(0, payloadEnd);

                    let payload: any = {};

                    try {
                        payload = JSON.parse(payloadString);
                    } catch (error) {
                        console.error(error);
                    }

                    if (payload.endOfMessage) {
                        //newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));
                    } else if (payload.resources) {
                        currentMessage.resources = payload.resources;

                        setConversation(newConversation.clone());
                        setChatUpdate(Date.now());
                    }

                    payloadString = null;
                    chunk = chunk.substring(payloadEnd + 3);
                } else {
                    payloadString += chunk;
                    chunk = '';
                }
            } else if (chunk.indexOf('```payload') >= 0) {
                const payloadStart = chunk.indexOf('```payload');
                currentMessage.content += chunk.substring(0, payloadStart);

                setConversation(newConversation.clone());
                setChatUpdate(Date.now());

                chunk = chunk.substring(payloadStart + 11);

                const payloadEnd = chunk.indexOf('```');

                if (payloadEnd >= 0) {
                    const payloadChunk = chunk.substring(0, payloadEnd);

                    let payload: any = {};

                    try {
                        payload = JSON.parse(payloadChunk);
                        console.log('Payload >>>', payload);
                    } catch (error) {
                        console.error(error);
                    }

                    if (payload.endOfMessage) {
                        console.log('===> End of message');

                        //newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));
                        // UpdateConversation loads conversations from server and binds current conversation with it 
                        // TODO Misleading identifier
                        properties.updateConversation?.(newConversation);
                        setPendingRequest(false);
                    } else if (payload.resources) {
                        currentMessage.resources = payload.resources;

                        console.log('===> Resources >>>', payload.resources);

                        setConversation(newConversation.clone());
                        setChatUpdate(Date.now());

                        const newSkillAgentResponse = payload.output ? payload.output : payload;
                        setSkillAgentResponse(newSkillAgentResponse);
                    }

                    payloadString = null;

                    chunk = chunk.substring(payloadEnd + 3);
                } else {
                    payloadString = chunk;
                    chunk = '';
                }
            } else {
                currentMessage.content += chunk;

                console.log('===> Current message >>>', currentMessage);

                setConversation(newConversation.clone());
                setChatUpdate(Date.now());

                chunk = '';
                payloadString = null;
            }
        }

        return { newConversation, payloadString };
    }

    const submitInput = useCallback(async (input: string) => {
        if (!input || input.trim().length === 0) {
            return;
        }

        input = capitalizeFirstLetter(input);

        const allowsConfirmation = conversation.length > 0 && (conversation[conversation.length - 1].type === 'botSuggestion' ||
            conversation[conversation.length - 1].confirmation);
        let newConversation = conversation.clone();

        console.log('===> Uploaded files >>>', uploadedFiles);

        newConversation.messages.push(new Message(MessageType.userMessage, input, false, []));

        console.log('===> New conversation >>>', newConversation);

        setConversation(newConversation);
        setInputValue(null);
        setShowSuggestions(false);
        setShowSampleRequests(false);
        scrollToBottom();

        if (allowsConfirmation) {
            if (input.trim().toLowerCase() === 'yes' && conversation.messages[conversation.messages.length - 1].type === 'botSuggestion') {
                input = conversation.messages[conversation.messages.length - 1].prompt;
            } else if (input.trim().toLowerCase() === 'no') {
                textField.current.focus();

                return;
            }
        } else {
            recordRequest(input);
        }

        setPendingRequest(true);

        try {
            // const payload = await userAPI.submitRequest(id, agent, selectedProfile.key, input,
            //     { location: { spaceName: selectedItem.key }, user: userContext, locale });

            // console.log('Payload >>>', payload);

            // const newSkillAgentResponse = payload.output ? payload.output : payload;

            // setAgent(payload.agent);
            // setSkillAgentResponse(newSkillAgentResponse);

            const userContext = {
                firstName: authentication.firstName,
                lastName: authentication.lastName,
                email: authentication.email
            };

            console.log('User context >>>', userContext);

            const responseStream = await userAPI.streamPromptResponse(conversation._id, agent, 'Profile1', input,
                { location: { spaceName: 'Space1' }, user: userContext, locale }, properties.toolFilter || []) as any;

            // if (newSkillAgentResponse.skill && newSkillAgentResponse.followUp === 'clientAction') {
            //     if (newSkillAgentResponse.resources && newSkillAgentResponse.resources[0] && newSkillAgentResponse.resources[0].path) {
            //         navigate(newSkillAgentResponse.resources[0].path);
            //     } else {
            //         // TODO Should generate error text
            //         toggleHideDialog();
            //     }
            // } else {        

            const decoderStream = new TextDecoderStream("utf-8");

            newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));

            let parsingState = {
                newConversation: newConversation.clone(),
                payloadString: null as any,
            };

            const writer = new WritableStream({
                write(chunk) {
                    console.log('### Chunk ###');

                    parsingState = parseMessageChunk(chunk, parsingState);
                },
                abort(reason) {
                    console.log('Stream aborted:', reason);
                    setPendingRequest(false);
                },
                close() {
                    console.log('Stream closed');
                    setPendingRequest(false);
                }
            });

            responseStream.body
                .pipeThrough(decoderStream)
                .pipeTo(writer);

            setShowSuggestions(false);
        } catch (error) {
            console.error(error);

            newConversation.messages.push(new Message(MessageType.botMessage, 'Ich scheine Kommunikationsprobleme zu haben.', false, []));

            setConversation(newConversation.clone());
            setShowSuggestions(false);
            setPendingRequest(false);

            return 'Ich scheine Kommunikationsprobleme zu haben.';
        }
    }, [agent, id, conversation, recordRequest]);

    const submitSuggestion = (suggestion: Suggestion) => {
        setInputValue(suggestion.examples[0]);
        setShowSuggestions(false);
        submitInput(suggestion.examples[0]);
    }

    const onKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            submitInput(inputValue);
        } else if (event.key === 'ArrowUp') {
            const newRequestIndex = Math.max(requestIndex - 1, 0);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        } else if (event.key === 'ArrowDown') {
            const newRequestIndex = Math.min(requestIndex + 1, requests.length - 1);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        }
    };

    useSpeech((text: string, final: any) => {
        setInputValue(text);

        if (final) {
            setTranscribing(false);
        }
    }, transcribing);

    useEffect(() => {
        setConversation(properties.conversation);

        if (!properties.conversation || !properties.conversation.messages || properties.conversation.messages.length === 0) {
            setShowSuggestions(properties.showSuggestions);
        }

        textField.current.focus();
    }, [properties.conversation, properties.showSuggestions]);

    useEffect(() => {
        scrollToBottom();
    }, [conversation, chatUpdate]);

    // TODO Cleanup!

    // useEffect(() => {
    //     scrollToBottom();
    //     // const socket = io(`${baseUrl}`);

    //     // socket.on("connect", () => {
    //     //     setId(socket.id);

    //     //     socket.on("suggestion", (suggestion) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botSuggestion',
    //     //             content: suggestion.message,
    //     //             prompt: suggestion.prompt,
    //     //         }]);

    //     //         textField.current.focus();
    //     //     });

    //     //     socket.on("message", (message) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botMessage',
    //     //             content: message
    //     //         }]);
    //     //     });
    //     // });
    // }, [chatUpdate]);

    useEffect(() => {
        if (!textField.current) {
            return;
        }

        if (!pendingRequest) {
            textField.current.focus();
        } else {
            textField.current.blur();
        }
    }, [pendingRequest]);

    // useEffect(() => {
    //     speechController.current.recognizingCallback = (text) => {
    //         setInputValue(text);
    //     }
    //     speechController.current.recognizedCallback = submitInput;
    //     speechController.current.stateChangeCallback = (state) => {
    //         setSpeechControllerState(state);
    //     }
    //     speechController.current.listen();
    // }, [speechController, submitInput]);

    // Add null check after all hooks to prevent errors when properties is null
    if (!properties || typeof properties !== "object") {
        console.error("[ChatExchange] called with invalid properties:", properties);
        return <div>Loading...</div>;
    }

    return (
        <div
            className={`${properties.fullWidth ? '' : 'paddingLeft200px paddingRight200px'} displayFlex flexDirectionColumn`}
            style={{
                height: properties.height || '100%',
                position: 'relative'
            }}
        >
            <div className='chat-conversation-area'>
                <div ref={conversationAreaRef} className='paddingM overflowYScroll' style={{ height: 'calc(100% - 20px)', maxHeight: 'calc(100% - 20px)' }}>
                    <ChatConversation
                        conversation={conversation}
                        pendingRequest={pendingRequest}
                        submitInput={submitInput}
                        onFeedback={handleFeedback}
                        resourceSelected={properties.resourceSelected}
                    />
                </div>
                {conversation ?
                    <>
                        {conversation.messages.length === 0
                            ?
                            (properties.showLogo ? <div className='logo marginBottomXXXL'>
                                {(() => {
                                    switch (authentication?.customer) {
                                        case 'A8Z1-ZQGN-YKN3': // BOSCH
                                            return <img className="botBrandingImage" src="/logos/bosch/schlaubi.jpeg" alt="logo" />;
                                        case 'C2Z2-QQGN-YKW6': // gefma
                                            return <img className="botBrandingImage" src="/logos/gefma/logo.png" alt="logo" />;
                                        case '4714': // Pastor
                                            return <img className="botBrandingImage" src="/logos/pastor/schlaubi.jpeg" alt="logo" />;
                                        default:
                                            return <img className="logoImage" src="/logo.png" alt="logo" />;
                                    }
                                })()}
                            </div> : <></>)
                            :
                            <></>
                        }
                    </>
                    :
                    <></>
                }
            </div>
            <div className={`chat-bottom-section ${properties.fullWidth ? 'no-padding' : ''}`}>
                {showSuggestions && !(inputValue && inputValue.trim().length > 0) ?
                    <Suggestions
                        onSuggestionClick={submitSuggestion}
                        onClose={() => setShowSuggestions(false)}
                    />
                    :
                    <div className="displayFlex justifyContentEnd">
                        {!showSuggestions && properties.showSuggestions && (
                            <div className="hoverHand marginTopS marginBottomS" onClick={() => setShowSuggestions(true)}>
                                {t('chatBotPage.needMoreIdeas')}
                            </div>
                        )}
                    </div>
                }
                            {properties.sampleRequests && properties.sampleRequests.length > 0 && !(inputValue && inputValue.trim().length > 0) && (
                <div className="sample-requests">
                    <div className='marginTopM marginBottomM'>
                        <ActionButton 
                            className="marginRightM" 
                            iconProps={{ 
                                iconName: showSampleRequests ? 'ChevronUp' : 'ChevronDown', 
                                style: { fontSize: '14px' } 
                            }} 
                            onClick={() => setShowSampleRequests(!showSampleRequests)}
                        >
                            <div className='colorPrimary'>Beispielanfragen</div>
                        </ActionButton>
                    </div>
                    {showSampleRequests && (
                        <div className="sample-requests-list">
                            {properties.sampleRequests.map((sampleRequest: string, index: number) => (
                                <div
                                    key={index}
                                    className="sample-request"
                                    onClick={() => submitInput(sampleRequest)}
                                >
                                    {sampleRequest}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
                <div className="height20">
                    {conversation && conversation.memorySize() > 10000000 &&
                        <MessageBar delayedRender={false} messageBarType={MessageBarType.error}>
                            <span className="textS">Der Speicherbedarf der Konversation ist {formatNumber1(conversation.memorySize() / 1000000)} MB
                                <a className="marginLeftXS hoverHand" onClick={() => properties.createConversation?.()}>
                                    Neue Konversation
                                </a>
                            </span>
                        </MessageBar>
                    }
                </div>
                <div
                    className="inputContainer"
                    style={{ position: 'relative' }}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                {isDragOver && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            pointerEvents: 'none',
                            border: '2px dashed var(--colorPrimary, #0078d4)',
                            borderRadius: '8px',
                            zIndex: 1000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'none',
                            transition: 'border-color 0.2s',
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'var(--colorPrimary, #0078d4)',
                            fontSize: '15px',
                            fontWeight: 500,
                            background: 'none',
                            boxShadow: 'none',
                            padding: 0,
                        }}>
                            <FontIcon iconName="Upload" style={{ fontSize: '22px', marginBottom: '4px', color: 'var(--colorPrimary, #0078d4)' }} />
                            <span>Drop file here</span>
                        </div>
                    </div>
                )}
                <div>
                    {/* Uploaded files list */}
                    {uploadedFiles.length > 0 && (
                        <div style={{ marginBottom: 8, display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                            {uploadedFiles.map((file, idx) => (
                                <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4, background: '#f5f5f5', borderRadius: 6, padding: '4px 10px', maxWidth: 220, minWidth: 0 }}>
                                    <FontIcon iconName="Page" style={{ fontSize: 18, marginRight: 8, color: 'var(--colorPrimary, #0078d4)' }} />
                                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{file.name}</span>
                                    <FontIcon 
                                        iconName="Delete" 
                                        style={{ fontSize: 18, marginLeft: 8, color: '#d13438', cursor: 'pointer' }} 
                                        title="Remove file"
                                        onClick={() => handleRemoveFile(idx)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="marginTopS displayFlex">
                    <TextField
                        className="flexGrow1"
                        componentRef={textField}
                        styles={{
                            fieldGroup: [
                                { width: '100%' },
                            ]
                        }}
                        placeholder={pendingRequest ? '' : (requests && requests.length > 0 ? `${t('chatBotPage.canIHelpWithAnythingElse')} ${requests.length > 0 ? '(⭡⭣' + t('chatBotPage.forHistory') + ')' : ''}` : `${t('chatBotPage.canIHelp')}`)}
                        value={inputValue}
                        disabled={pendingRequest}
                        onFocus={() => setInputFocussed(true)}
                        onBlur={() => setInputFocussed(false)}
                        onChange={(event, value) => setInputValue(value || '')}
                        onKeyDown={onKeyDown}
                    />
                    <div className='marginLeftS displayFlex gapM'>
                        {inputValue && inputValue.trim().length > 0 ? (
                            <div onClick={() => submitInput(inputValue)}>
                                <FontIcon iconName={'Send'} className="hoverHand textXL colorPrimary" aria-label="Send" />
                            </div>
                        ) : transcribing ? (
                            <div onClick={() => setTranscribing(false)}>
                                <FontIcon iconName={'CircleStopSolid'} className="hoverHand textXL colorRed pulsing" aria-label="Stop Recording" />
                            </div>
                        ) : (
                            <div onClick={() => setTranscribing(true)}>
                                <FontIcon iconName={'Microphone'} className="hoverHand textXL colorPrimary" aria-label="Start Recording" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}; 